import type {Flow} from "flow-to-typescript-codemod";

/**
 * Backbone Model that maps to an Affiliation in the datastore
 */
import Backbone from "./backbone-lite.js";

const instanceProperties = {
    defaults: {
        // Affiliation to initialize the EduorgPicker with
        eduorgKeyId: "",
        eduorgName: "",
        eduorgPostalCode: "",
        eduorgLocationText: "",
    },
} as const;

const AffiliationModel: Flow.Class<Backbone.Model & typeof instanceProperties> =
    Backbone.Model.extend(instanceProperties);

export {AffiliationModel};
